import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import {
  fetchTodoTasksApi,
  createTodoTaskApi,
  updateTaskStatusApi,
  deleteTodoTasksApi,
  updateTodoTaskApi,
} from "../../api/todoApi";

// GET API: Fetch all tasks
export const fetchTodoTasks = createAsyncThunk(
  "todo/fetchTodoTasks",
  async (coachId, { rejectWithValue }) => {
    try {
      const data = await fetchTodoTasksApi(coachId);

      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// POST API and UPDATE API remain unchanged
export const createTodoTask = createAsyncThunk(
  "todo/createTodoTask",
  async (taskPayload, { rejectWithValue }) => {
    try {
      const message = await createTodoTaskApi(taskPayload);
      return message;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateTodoTask = createAsyncThunk(
  "Dashboard/UpdateTodoTask",
  async (taskPayload, { rejectWithValue }) => {
    try {
      const message = await updateTodoTaskApi(taskPayload);
      return message;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateTaskStatus = createAsyncThunk(
  "todo/updateTaskStatus",
  async (taskStatusPayload, { rejectWithValue }) => {
    try {
      const message = await updateTaskStatusApi(taskStatusPayload);
      return message;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteTaskThunk = createAsyncThunk(
  "Dashboard/DeleteToDoTask",
  async (taskId, { rejectWithValue }) => {
    try {
      const message = await deleteTodoTasksApi(taskId);
      return message;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const todoSlice = createSlice({
  name: "todo",
  initialState: {
    overDueTodoTasks: [],
    todaysTodoTasks: [],
    tomorrowsTaskList: [],
    deletedMessage: null,
    isLoadingTask: false,
    loading: false,
    error: null,
    successMessage: null,
  },
  reducers: {
    clearSuccessMessage: (state) => {
      state.successMessage = null;
      state.deletedMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTodoTasks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTodoTasks.fulfilled, (state, action) => {
        state.loading = false;
        state.overDueTodoTasks = action?.payload?.overdueTaskList?.map(
          (task) => ({
            ...task,
            isSelected: false,
          })
        );

        state.todaysTodoTasks = action?.payload?.todaysTaskList?.map(
          (task) => ({
            ...task,
            isSelected: false,
          })
        );

        state.tomorrowsTaskList = action?.payload?.tomorrowsTaskList?.map(
          (task) => ({
            ...task,
            isSelected: false,
          })
        );
      })
      .addCase(fetchTodoTasks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(deleteTaskThunk.pending, (state) => {
        state.isLoadingTask = true;
        state.error = null;
      })
      .addCase(deleteTaskThunk.fulfilled, (state, action) => {
        state.isLoadingTask = false;
        state.deletedMessage = action.payload.message;
      })
      .addCase(deleteTaskThunk.rejected, (state, action) => {
        state.isLoadingTask = false;
        state.error = action.payload;
        state.deletedMessage = action.payload.message;
      })

      // Create Task
      .addCase(createTodoTask.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createTodoTask.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = action.payload;
      })
      .addCase(createTodoTask.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(updateTaskStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(updateTaskStatus.fulfilled, (state, action) => {
        const updatedTask = action.meta.arg; // Payload sent to the API

        // Update today's and tomorrow's tasks combined list
        state.todaysTodoTasks = state.todaysTodoTasks.map((task) =>
          task.taskId === updatedTask.taskId ? { ...task, status: true } : task
        );

        // Update overdue tasks list
        state.overDueTodoTasks = state.overDueTodoTasks.map((task) =>
          task.taskId === updatedTask.taskId ? { ...task, status: true } : task
        );

        state.loading = false;
        state.successMessage = action.payload;
      })

      .addCase(updateTaskStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearSuccessMessage } = todoSlice.actions;

export default todoSlice.reducer;
